// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/line_desktop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/banner_shop_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shop_container__Rufq5 {
  transition: all 0.2s linear;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 70px;
  width: 85%;
}
.Shop_container__Rufq5 .Shop_container__line__TdNwk {
  margin-top: 20px;
  border-radius: 8px;
  width: 100%;
  height: 52px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 0 10px;
}
.Shop_container__Rufq5 .Shop_container__line__TdNwk .Shop_title__iyk0e {
  font-weight: 400;
  font-size: 18px;
  line-height: 163%;
  color: #ffc785;
  padding-top: 10px;
}
.Shop_container__Rufq5 .Shop_container__line_mob__SyPyr {
  display: none;
}
.Shop_container__Rufq5 .Shop_container__title__8fnZF {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-top: 30px;
}
.Shop_container__Rufq5 .Shop_container__title__8fnZF .Shop_title__iyk0e {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  font-size: 40px;
}
.Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  width: 100%;
}
.Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ {
  margin-top: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: 119px;
  max-height: 60px;
  border-radius: 12px;
  display: flex;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv {
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
.Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner_p_one__UzCir {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
  color: #fff;
}
.Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner_p_two__NCaYt {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-size: 15px;
  color: #e8f0ff;
  font-weight: 400;
}
.Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner__group_img__Lpbhz {
  display: none;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;
  gap: 10px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 30px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_reset_filter__qOm9O {
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  color: #E0E0E0;
  display: flex;
  gap: 4px;
  align-items: center;
  white-space: nowrap;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container__Gc8va {
  display: flex;
  gap: 12px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container_item__dZvxn {
  background-color: rgba(255, 255, 255, 0.1);
  font-family: "Open Sans SemiBold";
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  border-radius: 100px;
  padding: 6px 8px;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container_item__dZvxn img {
  display: none;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_selected_chips__container_item__tqYya {
  background-color: rgba(255, 255, 255, 0.3);
  color: #fff;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_selected_chips__container_item__tqYya img {
  display: block;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K .Shop_chips__container_divider__Ud1TA {
  color: #fff;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN {
  font-family: "Open Sans SemiBold";
  font-size: 16px;
  align-items: center;
  background-color: #3e3c37;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: 4px;
  width: 138px;
  height: 42px;
  position: relative;
  transition: all 0.2s linear;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: #000000;
  border-radius: 8px;
  color: #e0e0e0;
  left: 0;
  padding: 8px 0;
  position: absolute;
  top: 120%;
  width: 170px;
  z-index: 1;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw .Shop_filterItem__nc6Uh {
  cursor: pointer;
  margin-bottom: 3px;
  padding: 6px 16px;
  transition: all 0.2s linear;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw .Shop_filterItem__nc6Uh:hover {
  background-color: rgba(220, 220, 220, 0.1);
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filter__WLyHN .Shop_filterWrapper__xmtgw .Shop_selectedFilter__Xqs1D {
  background-color: #3E3C37;
  color: #fff;
}
.Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI {
  display: none;
}
.Shop_container__Rufq5 .Shop_mobFilter__1-QND {
  display: none;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU {
  align-items: start;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-top: 50px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_loaderContainer__eMAAr {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #f9f9f9;
  display: flex;
  grid-column: span 4;
  justify-content: center;
  margin-top: 50px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_loaderContainer__eMAAr .Shop_loaderWrapper__IRTM8 {
  background-color: #ffffff;
  border-radius: 133px;
  height: 8px;
  margin-top: 32px;
  width: 236px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_loaderContainer__eMAAr .Shop_loaderWrapper__IRTM8 .Shop_loader__PVrLC {
  background-color: #4a2c6f;
  border-radius: 133px;
  height: 100%;
  animation: Shop_loader__PVrLC 0.5s ease-in-out forwards;
  width: 0;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  grid-column: span 4;
  margin-top: 50px;
  text-align: center;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa .Shop_emptyInfo__lQmg0 {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  margin-top: 20px;
}
.Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa .Shop_emptyInfo__lQmg0 .Shop_link__oVSYa {
  color: #F2F740;
}
.Shop_container__Rufq5 .Shop_more__FgEWY {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  position: relative;
}
.Shop_container__Rufq5 .Shop_more__FgEWY .Shop_down_button__Nicx5 {
  background: #3e3c37;
  border-radius: 12px;
  width: 78px;
  height: 42px;
  font-size: 16px;
  color: #fff;
  font-family: "Open Sans SemiBold";
  cursor: pointer;
}
.Shop_container__Rufq5 .Shop_up__9HpLo {
  align-items: center;
  background-color: #3e3c37;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  width: 42px;
  height: 42px;
  justify-content: center;
  position: absolute;
  right: 0;
  transition: all 0.2s linear;
}
.Shop_container__Rufq5 .Shop_modalOverlay__mbUG8 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

@keyframes Shop_loader__PVrLC {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
@media (max-width: 1200px) {
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 1100px) {
  .Shop_container__Rufq5 .Shop_container__filter__FspMS {
    align-items: flex-start;
    flex-direction: column;
    margin-top: 32px;
    gap: 16px;
    display: none;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_chips__rCH6K {
    display: none;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI {
    background-color: #333217;
    color: #F2F740;
    display: flex;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS .Shop_filterModal__MBXhI:hover {
    background-color: #494711;
  }
  .Shop_container__Rufq5 .Shop_mobFilter__1-QND {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
  }
  .Shop_container__Rufq5 .Shop_mobFilter__1-QND .Shop_mobFilter__games__mFyfs {
    display: flex;
    gap: 16px;
  }
  .Shop_container__Rufq5 .Shop_mobFilter__1-QND .Shop_mobFilter__games__mFyfs .Shop_mobFilter__game__saWEK {
    background-color: rgba(255, 255, 255, 0.1019607843);
    border-radius: 16px;
    color: #fff;
    padding: 6px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Shop_container__Rufq5 .Shop_mobFilter__1-QND .Shop_mobFilter__games__mFyfs .Shop_mobFilter__game__saWEK.Shop_active__fPfpU {
    background-color: rgba(255, 255, 255, 0.3019607843);
  }
}
@media (max-width: 920px) {
  .Shop_container__filter__FspMS .Shop_chips__rCH6K {
    display: flex;
    flex-direction: column;
  }
  .Shop_container__filter__FspMS .Shop_chips__container_divider__Ud1TA {
    display: none;
  }
}
@media (max-width: 900px) {
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner_p_one__UzCir {
    font-size: 18px;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner_p_two__NCaYt {
    font-size: 13px;
  }
}
@media (max-width: 850px) {
  .Shop_container__Rufq5 {
    padding-top: 75px;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__img__6QwPC {
    display: none;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ {
    background-image: none;
    max-height: none;
    border-radius: 8px;
    background: linear-gradient(90deg, #0051ff 0%, #0a74ff 100%);
    justify-content: center;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv {
    padding-top: 15px;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner_p_one__UzCir {
    font-size: 20px;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner_p_two__NCaYt {
    font-size: 14px;
  }
  .Shop_container__Rufq5 .Shop_banner_wrapper__pJJwN .Shop_banner__FIkiJ .Shop_banner__group__SBgPv .Shop_banner__group_img__Lpbhz {
    display: block;
    width: 100%;
  }
  .Shop_container__Rufq5 .Shop_container__title__8fnZF .Shop_title__iyk0e {
    display: block;
    font-size: 36px;
  }
  .Shop_container__Rufq5 .Shop_container__filter__FspMS {
    align-items: start;
  }
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU {
    grid-template-columns: 1fr;
    margin-top: 24px;
  }
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa {
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
  }
  .Shop_container__Rufq5 .Shop_wrapper__0a8zU .Shop_empty__GgfIa .Shop_emptyInfo__lQmg0 {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    margin-top: 20px;
  }
}
@media (max-width: 500px) {
  .Shop_container__Rufq5 .Shop_container__line__TdNwk {
    display: none;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr {
    margin-top: 20px;
    display: block;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    background: rgba(255, 112, 0, 0.25);
    display: flex;
    gap: 6px;
    padding: 10px 10px;
    align-items: center;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr .Shop_mob_line__N5FaG {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr .Shop_mob_line__N5FaG .Shop_title__iyk0e {
    font-weight: 600;
    font-size: 18px;
    line-height: 168%;
    color: #fff;
  }
  .Shop_container__Rufq5 .Shop_container__line_mob__SyPyr .Shop_mob_line__N5FaG .Shop_desc__ReiWU {
    font-family: var(--second-family);
    font-weight: 400;
    font-size: 12px;
    line-height: 173%;
    color: #ffc785;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Shop/Shop.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,2BAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AADF;AAEE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAJ;AACI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AACN;AAEE;EACE,aAAA;AAAJ;AAEE;ECWA,eAAA;EACA,gBAAA;EACA,kBAAA;EDXE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;AADI;EC/BF,eAAA;EACA,gBAAA;EACA,kBAAA;EDgCI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AAIN;AADE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAGJ;AAFI;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAIN;AADM;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;EAEA,kBAAA;EACA,mBAAA;AAER;AADQ;EChEN,eAAA;EACA,gBAAA;EACA,kBAAA;EDgEQ,eAAA;EACA,WAAA;AAKV;AAHQ;ECrEN,eAAA;EACA,gBAAA;EACA,kBAAA;EDqEQ,eAAA;EACA,cAAA;EACA,gBAAA;AAOV;AALQ;EACE,aAAA;AAOV;AADE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAGJ;AAFI;ECmDF,eAAA;EACA,gBAAA;EACA,kBAAA;EDnDI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAMN;AAJM;EACE,eAAA;EACA,mBAAA;EACA,eAAA;EACA,cEjHO;EFkHP,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;AAMR;AAHM;EACE,aAAA;EACA,SAAA;AAKR;AAHM;EACE,0CAAA;EACA,iCAAA;EACA,qEAAA;EACA,oBAAA;EACA,gBAAA;EAEA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAIR;AAFQ;EACE,aAAA;AAIV;AADM;EACE,0CAAA;EACA,WAAA;EACA,qEAAA;AAGR;AADQ;EACE,cAAA;AAGV;AAAM;EACE,WAAA;AAER;AAEI;EACE,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAAN;AAEM;ECpBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDqBM,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AACR;AACQ;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;AACV;AACU;EACE,0CAAA;AACZ;AAGQ;EACE,yBAAA;EACA,WAAA;AADV;AAUI;EACE,aAAA;AARN;AAYE;EACE,aAAA;AAVJ;AAaE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sCAAA;EACA,gBAAA;AAXJ;AAaI;ECnNF,eAAA;EACA,gBAAA;EACA,kBAAA;EDoNI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAVN;AAYM;EACE,yBEhPE;EFiPF,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAVR;AAYQ;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,uDAAA;EACA,QAAA;AAVV;AAeI;ECnPF,eAAA;EACA,gBAAA;EACA,kBAAA;EDoPI,cEnQI;EFoQJ,mBAAA;EACA,gBAAA;EACA,kBAAA;AAZN;AAcM;EC7NJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED8NM,gBAAA;AAXR;AAaQ;EACE,cErQC;AF0PX;AAiBE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAgBI;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,iCAAA;EACA,eAAA;AAdN;AAkBE;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAhBJ;AAwBE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAvBJ;;AA4BA;EACE;IACE,QAAA;EAzBF;EA4BA;IACE,WAAA;EA1BF;AACF;AA6BA;EAEI;IACE,kCAAA;EA5BJ;AACF;AAgCA;EAEI;IACE,uBAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,aAAA;EA/BJ;EAiCI;IACE,aAAA;EA/BN;EAkCI;IACE,yBE7VQ;IF8VR,cEhWG;IFiWH,aAAA;EAhCN;EAkCM;IACE,yBAAA;EAhCR;EAqCE;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,gBAAA;EAnCJ;EAqCI;IACE,aAAA;IACA,SAAA;EAnCN;EAqCM;IACE,mDAAA;IACA,mBAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;EAnCR;EAqCQ;IACE,mDAAA;EAnCV;AACF;AA0CA;EAEI;IACE,aAAA;IACA,sBAAA;EAzCJ;EA2CE;IACE,aAAA;EAzCJ;AACF;AA6CA;EAKU;IACE,eAAA;EA/CV;EAiDQ;IACE,eAAA;EA/CV;AACF;AAsDA;EACE;IA2BE,iBAAA;EA9EF;EAqDI;IACE,aAAA;EAnDN;EAqDI;IACE,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,4DAAA;IACA,uBAAA;EAnDN;EAoDM;IACE,iBAAA;EAlDR;EAmDQ;IACE,eAAA;EAjDV;EAmDQ;IACE,eAAA;EAjDV;EAmDQ;IACE,cAAA;IACA,WAAA;EAjDV;EAyDI;IACE,cAAA;IACA,eAAA;EAvDN;EA2DE;IACE,kBAAA;EAzDJ;EA8DE;IACE,0BAAA;IACA,gBAAA;EA5DJ;EA8DI;ICtcJ,eAAA;IACA,gBAAA;IACA,kBAAA;ED2YA;EA4DM;IC7TN,eAAA;IACA,gBAAA;IACA,kBAAA;ID8TQ,gBAAA;EAzDR;AACF;AA+DA;EAEI;IACE,aAAA;EA9DJ;EAgEE;IACE,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mCAAA;IACA,aAAA;IACA,QAAA;IACA,kBAAA;IACA,mBAAA;EA9DJ;EA+DI;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EA7DN;EA8DM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;EA5DR;EA8DM;IACE,iCAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;EA5DR;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.container {\n  transition: all 0.2s linear;\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: 70px;\n  width: 85%;\n  .container__line {\n    margin-top: 20px;\n    border-radius: 8px;\n    width: 100%;\n    height: 52px;\n    background-image: url(\"../../assets/images/line_desktop.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 0 10px;\n    .title {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 163%;\n      color: #ffc785;\n      padding-top: 10px;\n    }\n  }\n  .container__line_mob {\n    display: none;\n  }\n  .container__title {\n    @include subtitle5;\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    margin-top: 30px;\n    .title {\n      @include h2;\n\n      align-items: center;\n      color: #ffffff;\n      display: flex;\n      justify-content: space-between;\n      font-size: 40px;\n    }\n  }\n  .banner_wrapper {\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    width: 100%;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    width: 100%;\n    .banner {\n      margin-top: 20px;\n      background-image: url(\"../../assets/images/banner_shop_bg.png\");\n      background-repeat: no-repeat;\n      background-size: cover;\n      width: 100%;\n      min-height: 119px;\n      max-height: 60px;\n      border-radius: 12px;\n      display: flex;\n      background-position: right;\n      background-repeat: no-repeat;\n      background-size: cover;\n      justify-content: space-between;\n      align-items: center;\n      position: relative;\n      .banner__img {\n      }\n      .banner__group {\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        gap: 5px;\n\n        padding-left: 15px;\n        padding-right: 15px;\n        .banner_p_one {\n          @include subtitle1b;\n          font-size: 22px;\n          color: #fff;\n        }\n        .banner_p_two {\n          @include subtitle1b;\n          font-size: 15px;\n          color: #e8f0ff;\n          font-weight: 400;\n        }\n        .banner__group_img {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .container__filter {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: end;\n    flex-wrap: wrap;\n    gap: 10px;\n    .chips {\n      @include body1;\n      display: flex;\n      gap: 12px;\n      align-items: center;\n      margin-top: 30px;\n\n      .reset_filter {\n        cursor: pointer;\n        white-space: nowrap;\n        font-size: 14px;\n        color: $c-light-grey;\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        white-space: nowrap;\n      }\n\n      .chips__container {\n        display: flex;\n        gap: 12px;\n      }\n      .chips__container_item {\n        background-color: rgba(255, 255, 255, 0.1);\n        font-family: \"Open Sans SemiBold\";\n        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n        border-radius: 100px;\n        padding: 6px 8px;\n\n        color: #ffffff;\n        cursor: pointer;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-size: 14px;\n\n        img {\n          display: none;\n        }\n      }\n      .selected_chips__container_item {\n        background-color: rgba(255, 255, 255, 0.3);\n        color: #fff;\n        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\n        img {\n          display: block;\n        }\n      }\n      .chips__container_divider {\n        color: #fff;\n      }\n    }\n\n    .filter {\n      font-family: \"Open Sans SemiBold\";\n      font-size: 16px;\n      align-items: center;\n      background-color: #3e3c37; \n      border-radius: 12px;\n      color: #fff;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      gap: 4px;\n      width: 138px;\n      height: 42px;\n      position: relative;\n      transition: all 0.2s linear;\n\n      .filterWrapper {\n        @include body1;\n\n        background-color: #000000;\n        border-radius: 8px;\n        color: #e0e0e0;\n        left: 0;\n        padding: 8px 0;\n        position: absolute;\n        top: 120%;\n        width: 170px;\n        z-index: 1;\n\n        .filterItem {\n          cursor: pointer;\n          margin-bottom: 3px;\n          padding: 6px 16px;\n          transition: all 0.2s linear;\n\n          &:hover {\n            background-color: rgba(220, 220, 220, 0.1);\n          }\n        }\n\n        .selectedFilter {\n          background-color: #3E3C37;\n          color: #fff;\n        }\n      }\n\n      // &:hover {\n      //   background-color: #4a2c6f;\n      // }\n    }\n\n    .filterModal {\n      display: none;\n    }\n  }\n\n  .mobFilter {\n    display: none;\n  }\n\n  .wrapper {\n    align-items: start;\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    margin-top: 50px;\n\n    .loaderContainer {\n      @include subtitle1b;\n\n      color: #f9f9f9;\n      display: flex;\n      grid-column: span 4;\n      justify-content: center;\n      margin-top: 50px;\n\n      .loaderWrapper {\n        background-color: $c-white;\n        border-radius: 133px;\n        height: 8px;\n        margin-top: 32px;\n        width: 236px;\n\n        .loader {\n          background-color: #4a2c6f;\n          border-radius: 133px;\n          height: 100%;\n          animation: loader 0.5s ease-in-out forwards;\n          width: 0;\n        }\n      }\n    }\n\n    .empty {\n      @include h3;\n\n      color: $c-white;\n      grid-column: span 4;\n      margin-top: 50px;\n      text-align: center;\n\n      .emptyInfo {\n        @include subtitle5;\n\n        margin-top: 20px;\n\n        .link {\n          color: $c-yellow;\n        }\n      }\n    }\n  }\n\n  .more {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    position: relative;\n    .down_button {\n      background: #3e3c37;\n      border-radius: 12px;\n      width: 78px;\n      height: 42px;\n      font-size: 16px;\n      color: #fff;\n      font-family: \"Open Sans SemiBold\";\n      cursor: pointer;\n    }\n  }\n\n  .up {\n    align-items: center;\n    background-color: #3e3c37;;\n    border-radius: 100px; \n    cursor: pointer;\n    display: flex;\n    width: 42px;\n    height: 42px;\n    justify-content: center;\n    position: absolute;\n    right: 0;\n    transition: all 0.2s linear;\n    \n\n    // &:hover {\n    //   background-color: #4a2c6f;\n    // }\n  }\n\n  .modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    \n  }\n}\n\n@keyframes loader {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1200px) {\n  .container {\n    .wrapper {\n      grid-template-columns: 1fr 1fr 1fr;\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n    .container__filter {\n      align-items: flex-start;\n      flex-direction: column;\n      margin-top: 32px;\n      gap: 16px;\n      display: none;\n\n      .chips {\n        display: none;\n      }\n\n      .filterModal {\n        background-color: $c-dark-yellow;\n        color: $c-yellow;\n        display: flex;\n\n        &:hover {\n          background-color: #494711;\n        }\n      }\n    }\n\n    .mobFilter {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;     \n      margin-top: 20px;\n      \n      .mobFilter__games {\n        display: flex;\n        gap: 16px;\n\n        .mobFilter__game {\n          background-color: #FFFFFF1A;\n          border-radius: 16px;\n          color: #fff;\n          padding: 6px 8px;\n          display: flex;\n          align-items: center;\n          gap: 4px;\n\n          &.active {\n            background-color: #FFFFFF4D;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 920px) {\n  .container__filter {\n    .chips {\n      display: flex;\n      flex-direction: column;\n    }\n    .chips__container_divider {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 900px) {\n  .container {\n    .banner_wrapper {\n      .banner {\n        .banner__group {\n          .banner_p_one {\n            font-size: 18px;\n          }\n          .banner_p_two {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    .banner_wrapper {\n      .banner__img {\n        display: none;\n      }\n      .banner {\n        background-image: none;\n        max-height: none;\n        border-radius: 8px;\n        background: linear-gradient(90deg, #0051ff 0%, #0a74ff 100%);\n        justify-content: center;\n        .banner__group {\n          padding-top: 15px;\n          .banner_p_one {\n            font-size: 20px;\n          }\n          .banner_p_two {\n            font-size: 14px;\n          }\n          .banner__group_img {\n            display: block;\n            width: 100%;\n          }\n        }\n      }\n    }\n\n    padding-top: 75px;\n    .container__title {\n      .title {\n        display: block;\n        font-size: 36px;\n      }\n    }\n\n    .container__filter {\n      align-items: start;\n      .filter {\n      }\n    }\n\n    .wrapper {\n      grid-template-columns: 1fr;\n      margin-top: 24px;\n\n      .empty {\n        @include subtitle1b;\n\n        .emptyInfo {\n          @include body1;\n\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .container {\n    .container__line {\n      display: none;\n    }\n    .container__line_mob {\n      margin-top: 20px;\n      display: block;\n      border-radius: 8px;\n      width: 100%;\n      height: 100%;\n      background: rgba(255, 112, 0, 0.25);\n      display: flex;\n      gap: 6px;\n      padding: 10px 10px;\n      align-items: center;\n      .mob_line {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .title {\n          font-weight: 600;\n          font-size: 18px;\n          line-height: 168%;\n          color: #fff;\n        }\n        .desc {\n          font-family: var(--second-family);\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 173%;\n          color: #ffc785;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #EAD40C;\n$icon-secondary: #7B756B;\n$icon-chevron: #BBB5AA;\n$icon-always-dark: #212329;\n$icon-primary-control: #292621;\n$icon-hover: #575249;\n$icon-pressed: #575249;\n$icon-white: #ffffff;\n$icon-notification: #FF3333;\n$icon-warning: #E2B603;\n$icon-deposit: #009E69;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #171716;\n$background-secondary: #292621;\n$background-snackbar: #000000;\n$background-input: #3E3C37;\n\n$control-primary: #F2F740;\n$control-hover: #F5F966;\n$control-pressed: #E6EB3D;\n$control-green: #009E69;\n$control-green-hover: #33B187;\n$control-green-pressed: #009664;\n$control-dark: #3E3C37;\n$control-dark-hover: #51504B;\n$control-dark-pressed: #3B3934;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n\n$text-title: #FAF9F8;\n$text-subtitle: #DAD6CE;\n$text-body: #C2BDB2;\n$text-link: #00D68F;\n$text-error: #FF3333;\n$text-warning: #E2B603;\n$text-white: #FFFFFF;\n$text-dark: #292621;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Shop_container__Rufq5`,
	"container__line": `Shop_container__line__TdNwk`,
	"title": `Shop_title__iyk0e`,
	"container__line_mob": `Shop_container__line_mob__SyPyr`,
	"container__title": `Shop_container__title__8fnZF`,
	"banner_wrapper": `Shop_banner_wrapper__pJJwN`,
	"banner": `Shop_banner__FIkiJ`,
	"banner__group": `Shop_banner__group__SBgPv`,
	"banner_p_one": `Shop_banner_p_one__UzCir`,
	"banner_p_two": `Shop_banner_p_two__NCaYt`,
	"banner__group_img": `Shop_banner__group_img__Lpbhz`,
	"container__filter": `Shop_container__filter__FspMS`,
	"chips": `Shop_chips__rCH6K`,
	"reset_filter": `Shop_reset_filter__qOm9O`,
	"chips__container": `Shop_chips__container__Gc8va`,
	"chips__container_item": `Shop_chips__container_item__dZvxn`,
	"selected_chips__container_item": `Shop_selected_chips__container_item__tqYya`,
	"chips__container_divider": `Shop_chips__container_divider__Ud1TA`,
	"filter": `Shop_filter__WLyHN`,
	"filterWrapper": `Shop_filterWrapper__xmtgw`,
	"filterItem": `Shop_filterItem__nc6Uh`,
	"selectedFilter": `Shop_selectedFilter__Xqs1D`,
	"filterModal": `Shop_filterModal__MBXhI`,
	"mobFilter": `Shop_mobFilter__1-QND`,
	"wrapper": `Shop_wrapper__0a8zU`,
	"loaderContainer": `Shop_loaderContainer__eMAAr`,
	"loaderWrapper": `Shop_loaderWrapper__IRTM8`,
	"loader": `Shop_loader__PVrLC`,
	"empty": `Shop_empty__GgfIa`,
	"emptyInfo": `Shop_emptyInfo__lQmg0`,
	"link": `Shop_link__oVSYa`,
	"more": `Shop_more__FgEWY`,
	"down_button": `Shop_down_button__Nicx5`,
	"up": `Shop_up__9HpLo`,
	"modalOverlay": `Shop_modalOverlay__mbUG8`,
	"mobFilter__games": `Shop_mobFilter__games__mFyfs`,
	"mobFilter__game": `Shop_mobFilter__game__saWEK`,
	"active": `Shop_active__fPfpU`,
	"banner__img": `Shop_banner__img__6QwPC`,
	"mob_line": `Shop_mob_line__N5FaG`,
	"desc": `Shop_desc__ReiWU`
};
export default ___CSS_LOADER_EXPORT___;
